var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreatorMarketplace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 10,
    fill: "url(#paint0_linear_14_11099)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.11133,
    y: 3.11108,
    width: 63.7778,
    height: 63.7778,
    rx: 10,
    fill: "#666CFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14_11099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 34.8167C12 33.4926 12.2387 32.1991 12.716 30.9361C13.2141 29.6528 13.9301 28.4917 14.864 27.4528C15.7979 26.3935 16.9393 25.5583 18.2883 24.9472C19.6372 24.3157 21.173 24 22.8955 24C24.9294 24 26.683 24.438 28.1565 25.3139C29.6508 26.1898 30.7611 27.3306 31.4874 28.7361L28.1876 30.9667C27.8141 30.1519 27.3264 29.5102 26.7245 29.0417C26.1227 28.5528 25.4793 28.2167 24.7945 28.0333C24.1096 27.8296 23.4351 27.7278 22.771 27.7278C21.6918 27.7278 20.7476 27.9417 19.9382 28.3694C19.1495 28.7972 18.4854 29.3574 17.9458 30.05C17.4063 30.7426 17.0016 31.5167 16.7318 32.3722C16.4827 33.2278 16.3582 34.0833 16.3582 34.9389C16.3582 35.8963 16.5139 36.8231 16.8252 37.7194C17.1365 38.5954 17.5723 39.3796 18.1326 40.0722C18.7137 40.7444 19.3986 41.2843 20.1872 41.6917C20.9966 42.0787 21.8786 42.2722 22.8333 42.2722C23.5181 42.2722 24.2134 42.1602 24.919 41.9361C25.6246 41.712 26.2783 41.3556 26.8802 40.8667C27.482 40.3778 27.949 39.7463 28.281 38.9722L31.7987 40.9583C31.3629 42.038 30.6469 42.9546 29.6508 43.7083C28.6754 44.462 27.5754 45.0324 26.351 45.4194C25.1265 45.8065 23.9124 46 22.7088 46C21.1315 46 19.6891 45.6843 18.3817 45.0528C17.0742 44.4009 15.9431 43.5454 14.9885 42.4861C14.0546 41.4065 13.3178 40.2046 12.7783 38.8806C12.2594 37.5361 12 36.1815 12 34.8167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.704 45.8167V31.5778L47.0384 42.1806H44.6414L38.9757 31.5778V45.8167H34.6797V24.1222H39.287L45.8243 36.4667L52.4239 24.1222H57V45.8167H52.704Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14_11099",
    x: 6,
    y: 22,
    width: 57,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14_11099"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14_11099",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_11099",
    x1: 67.2778,
    y1: 1.55555,
    x2: 1.55555,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666CFF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatorMarketplace);
export default __webpack_public_path__ + "static/media/creator_marketplace.ab867b0b19fe32162aaecb5c4f695a8b.svg";
export { ForwardRef as ReactComponent };